<template>
    <router-view></router-view>
</template>

<script>
</script>

<style lang="scss">
html,body,#app {
    margin:0;
    border:0;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.pager {
    width: 100%;
}
.form-hint {
    margin: 0 20px 10px 0;
    color: var(--scheme-2-color5);
}
.container {
    margin: 10px;
}
.page-title{
    color: var(--scheme-2-color9);
    height: 30px;
    line-height: 30px;
}
.page-title-btn {
    margin-left: 0.5em;
    line-height: 30px;
    vertical-align: top;
}
.btn-wrap {
    text-align: center;
    margin-top: 20px;
}
.form-btn-wrap {
    text-align: center;
    margin-top: 50px;
    .el-button {
        font-size: 16px;
        padding: 1.5em 2.5em;
        border-radius: 30px;
    }
    .el-button:hover {
        box-shadow: var(--gray-color5) 0 2px 6px;
    }
}
.form-dialog {
    min-height: 300px;
    .btn-wrap {
        margin-top: 40px;
        margin-bottom: 20px;
    }
}
.form-dialog-wide {
    min-height: 300px;
    width: 80% !important;
    .btn-wrap {
        margin-top: 40px;
    }
}
.dialog-form {
    margin-top: 30px;
}
</style>


